import Vue from 'vue';

/// ////////////////////////////
/// OFFICIAL COMPONENTS
/// ////////////////////////////
import VueLayers from 'vuelayers';
import BootstrapVue from 'bootstrap-vue';
import VueShortkey from 'vue-shortkey';
import LoadScript from 'vue-plugin-load-script';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

Vue.use(BootstrapVue);
Vue.use(VueLayers);
Vue.use(VueShortkey);
Vue.use(LoadScript);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

const c1 = require.context('../components/', true, /\.(vue)$/i);
c1.keys().map((key) => {
	if (c1(key).default.name !== undefined) {
		return Vue.component(c1(key).default.name, c1(key).default);
	}

	return false;
});
/// ////////////////////////////
// CUSTOM COMPONENTS
/// ////////////////////////////

try {
	const c2 = require.context('../../application/components/', true, /\.(vue)$/i);
	c2.keys().map((key) => {
		if (c2(key).default.name !== undefined) {
			return Vue.component(c2(key).default.name, c2(key).default);
		}

		return false;
	});
} catch (error) {
	console.error('Ocurrió un error al cargar lo componentes del proyecto', error);
}
